/**
 * Title Case for headings, labels and column headers (Chicago-style, kept simple):
 * capitalize every word except short joining words that are not first or last, and leave any word
 * that already has a capital or a digit after its first letter alone (AI, GA4, CSV, URL, eBay).
 * Non-string values pass through untouched.
 */
const SMALL = new Set(['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'into', 'nor', 'of', 'on', 'or', 'per', 'the', 'to', 'vs', 'via', 'with']);

function capWord(w: string): string {
  const m = /^([^\p{L}\p{N}]*)(\p{L})(.*)$/u.exec(w);
  if (!m) return w;
  const [, lead, first, rest] = m;
  if (/[\p{Lu}\p{N}]/u.test(rest) || /[./@]/.test(rest)) return w; // AI, GA4, example.com, owner@x
  return lead + first.toUpperCase() + rest;
}

export function titleCase(s: string): string {
  const parts = s.split(/(\s+|-)/);
  const words = parts.filter((p) => p.trim() && p !== '-');
  let wi = 0;
  return parts
    .map((p) => {
      if (!p.trim() || p === '-') return p;
      const i = wi++;
      const bare = p.toLowerCase().replace(/[^\p{L}]/gu, '');
      if (i > 0 && i < words.length - 1 && SMALL.has(bare) && p === p.toLowerCase()) return p;
      return capWord(p);
    })
    .join('');
}

export function tc<T>(v: T): T {
  return (typeof v === 'string' ? titleCase(v) : v) as T;
}
